/**
 * GDPR-compliant cookie consent types.
 * Consent is stored in localStorage and used to gate tracking scripts.
 */

export const CONSENT_VERSION = '1.0';
export const CONSENT_STORAGE_KEY = 'lureo_cookie_consent';

export type ConsentCategory = 'necessary' | 'analytics' | 'functional' | 'marketing';

export interface CookieConsent {
  necessary: boolean;
  analytics: boolean;
  functional: boolean;
  marketing: boolean;
  timestamp: string;
  version: string;
}

export const DEFAULT_CONSENT: CookieConsent = {
  necessary: true,
  analytics: false,
  functional: false,
  marketing: false,
  timestamp: '',
  version: CONSENT_VERSION,
};

export const ACCEPT_ALL_CONSENT: Omit<CookieConsent, 'timestamp' | 'version'> = {
  necessary: true,
  analytics: true,
  functional: true,
  marketing: true,
};

export const REJECT_ALL_CONSENT: Omit<CookieConsent, 'timestamp' | 'version'> = {
  necessary: true,
  analytics: false,
  functional: false,
  marketing: false,
};
